import { IS_DOCUMENTS_DOMAIN } from 'reactApp/appHelpers/configHelpers';
import { closeSharingNew } from 'reactApp/components/SharingNewBiz/SharingNew.helpers';
import { ROOT_FOLDER_ID } from 'reactApp/constants/magicIdentificators';
import { getGoToAndScrollUrl } from 'reactApp/modules/modifying/modifying.helpers';
import { getCurrentStorage } from 'reactApp/modules/router/router.selectors';
import { scrollToHomeItemAction } from 'reactApp/modules/selections/selections.actions';
import { getStorage } from 'reactApp/modules/storage/storage.helpers';
import { store as reduxStore } from 'reactApp/store';
import { changeDocumentDomainToCloud } from 'reactApp/utils/documentsDomain';
import opener from 'reactApp/utils/opener';
import { getEncodePath } from 'reactApp/utils/urlHelper';

export const showInParentFolder = ({ folderId, itemId }: { folderId: string; itemId?: string }) => {
    const state = reduxStore.getState();
    const storage = getCurrentStorage(state);

    const { isPublic, isStock } = getStorage(storage);

    if (isStock || isPublic || IS_DOCUMENTS_DOMAIN) {
        const selectedFolderId = folderId === ROOT_FOLDER_ID ? '' : getEncodePath(folderId);
        const path = getGoToAndScrollUrl(selectedFolderId, itemId);
        const host = IS_DOCUMENTS_DOMAIN ? changeDocumentDomainToCloud(window.location.origin) : window.location.origin;
        const url = `${host}${path}`;

        opener(url, true);
        return;
    }

    reduxStore.dispatch(scrollToHomeItemAction({ parentFolderId: folderId, itemId }));
    closeSharingNew();
};
